<template>
  <div>
    <v-container class="mb-4">
      <v-subheader>Selecione os estados onde sua empresa faz <b> coleta</b></v-subheader>
      <div>Você receberá as cotações de acordo
        com os locais escolhidos. Você poderá alterar esta informação nas
        configurações da sua empresa.
      </div>
      <px-lista-selecao-estados class="mt-2"
                                :empresa="empresa"
                                v-model="empresa.locaisColeta"
                                :max-select="27"
                                @reset="onReset()"/>
    </v-container>
    <v-btn color="primary"
           class="mr-2"
           :disabled="!empresa.locaisColeta.length"
           :loading="loadingForm"
           @click="$emit('ready')">
      Enviar
    </v-btn>
    <v-btn @click="$emit('back')">
      Voltar
    </v-btn>
  </div>
</template>

<script>
import PxListaSelecaoEstados from './lista-selecao-estado/PxListaSelecaoEstados.vue';

export default {
  props: {
    empresa: Object,
    loadingForm: Boolean,
  },
  methods: {
    onReset() {
      this.empresa.locaisColeta = [];
    },
  },
  components: {
    PxListaSelecaoEstados,
  },
};
</script>
